import React, { useState } from 'react';
import styled from 'styled-components';
import { Typography, Grid } from '@material-ui/core';
import { colors } from 'styles';
import { FormattedMessage } from 'react-intl';
import Layout from 'components/layout';
import { Switch } from 'components/basics';
import SyntheticPlansBlock from 'components/pages/Pricing/SyntheticPlans/SyntheticPlansBlock';
import DetailedPlansBlock from 'components/pages/Pricing/DetailedPlans/DetailedPlansBlock';
import FAQBlock from 'components/pages/Pricing/FAQ/FAQBlock';
import LinkBlocks from 'components/LinkBlock/LinkBlocks';
import LinkBlockBackground from 'components/pages/Solution/Marketing/LinkBlockBackground';
import { breakpoint } from '../../utils/mediaQueries';

const SwitchContainer = styled.div`
  margin-bottom: -1em;
  display: flex;
  align-items: center;
  justify-content: center;
  /* position: sticky; */
  /* top: 0; */
  width: 100%;
  z-index: 9999;
  /* background-color: ${colors.shades.grey.light}; */
`;

const LinkGrid = styled(Grid)`
  margin-top: -2.25rem;
  position: relative;
  /* padding-top: 10rem; */
  padding-bottom: 4rem;
  background-position: top;
  ${breakpoint.down('lg')`
  padding-top: 6rem;padding-bottom: 2rem;margin-top: 0;`}
  ${breakpoint.down('md')`
  padding-bottom: 4rem;`}
  ${breakpoint.down('sm')`padding-top:0;padding-bottom: 6rem;`};
`;

const LaunchOffer = styled(Typography)`
  color: ${colors.white};
  font-weight: bold;
  text-align: center;
  cursor: pointer;
  text-decoration: underline;
`;

const Banner = styled.div`
  background: ${colors.lightBlue};
  color: ${colors.white};
  padding: 0.5em;
`;

const SwitchLabel = styled(Typography)`
  color: ${colors.purple};
  font-weight: bold;
`;
const PricingPage = props => {
  const [isMonthlySelected, setMonthlySelected] = useState(false);
  const {
    dataSyntheticPricing: { nodes: syntheticPlans },
    dataDetailedPricing: { nodes: detailedPlans },
    dataQuestionsFaqBlock: { nodes: faq },
    dataFooterFaqBlock,
  } = props.data;

  const linkBlocksData = {
    markdownContent: props.data.dataBlockLinkBody,
  };
  return (
    <Layout location={props.location} seo={props.seo}>
      <h1 style={{ display: 'none' }}>
        <FormattedMessage id="pricing.title" />
      </h1>
      <Banner>
        <LaunchOffer
          variant="body2"
          onClick={() => window.open('https://cxinsights.io/sign-up')}
        >
          <FormattedMessage id="pricing.freeTrial" />
        </LaunchOffer>
      </Banner>
      <SwitchContainer>
        <SwitchLabel variant="body2">
          <FormattedMessage id="pricing.yearly" />
        </SwitchLabel>
        <Switch
          checked={isMonthlySelected}
          onChange={() => setMonthlySelected(!isMonthlySelected)}
        />
        <SwitchLabel variant="body2">
          <FormattedMessage id="pricing.monthly" />
        </SwitchLabel>
      </SwitchContainer>
      <SyntheticPlansBlock
        plans={syntheticPlans}
        isMonthlySelected={isMonthlySelected}
        setMonthlySelected={setMonthlySelected}
      />
      <DetailedPlansBlock
        isMonthlySelected={isMonthlySelected}
        setMonthlySelected={setMonthlySelected}
        plans={detailedPlans}
      />
      <FAQBlock data={faq} footer={dataFooterFaqBlock} />
      <LinkGrid>
        <LinkBlocks
          data={linkBlocksData.markdownContent.nodes}
          lang={props.pageContext.lang}
        />
      </LinkGrid>
    </Layout>
  );
};

export default PricingPage;
